import { Component } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';

@Component({
  selector: 'app-promo-renovacion',
  imports: [HeaderComponent, FooterComponent],
  templateUrl: './promo-renovacion.component.html',
  styleUrl: './promo-renovacion.component.scss'
})
export class PromoRenovacionComponent {
  footerColorClass = 'footer-promotor';
}
